import { api } from '../api.js';
import { renderHeader, bindHeader } from '../components/header.js';
import { toast } from '../utils/toast.js';

export async function renderAdminSettingsPage({ root }) {
  root.innerHTML = renderHeader({ active: 'admin-settings' }) + `
    <div class="container admin-container">
      <h1 class="admin-title">Настройки</h1>
      <div id="settings-body" class="admin-settings-body">Загрузка…</div>
    </div>
  `;
  bindHeader();
  const body = root.querySelector('#settings-body');

  async function reload() {
    try {
      const [integrations, limits, typingGate] = await Promise.all([
        api.adminSettings.getIntegrations(),
        api.adminSettings.getLimits(),
        api.adminSettings.getTypingGate(),
      ]);
      render(integrations, limits, typingGate);
      await loadWaitlist();
    } catch (err) {
      if (err.status === 403) body.innerHTML = '<div class="text-muted">Нужны права администратора.</div>';
      else body.textContent = 'Ошибка: ' + (err.message || '');
    }
  }

  function render(data, limits, gate) {
    const tg = data.telegram;
    body.innerHTML = `
      <details class="settings-card">
        <summary class="settings-card-head">
          <div>
            <h2>Telegram</h2>
            <p class="text-muted">Уведомления о новых тикетах, регистрациях и PIN-кодах админа летят в этот чат.</p>
          </div>
          <div class="settings-card-status">
            ${tg.hasBotToken && tg.adminChatId
              ? '<span class="status-pill status-open">Подключено</span>'
              : (data.envFallback.botToken && data.envFallback.chatId
                  ? '<span class="status-pill status-waiting">Из env</span>'
                  : '<span class="status-pill status-resolved">Не настроено</span>')}
          </div>
        </summary>
        <form id="tg-form" class="settings-form">
          <div class="field">
            <label>Bot token</label>
            <input type="password" id="f-token" placeholder="${tg.botTokenPreview ?? 'вставить токен бота'}" autocomplete="off" />
            <div class="field-hint text-muted">Оставь пустым, чтобы не менять. Очистить — кнопка ниже.</div>
          </div>
          <div class="field">
            <label>Admin chat ID</label>
            <input type="text" id="f-chat" value="${escapeHtml(tg.adminChatId)}" placeholder="например, -1001234567890" autocomplete="off" />
            <div class="field-hint text-muted">ID чата, куда будут приходить уведомления. Для личного чата — твой user ID.</div>
          </div>
          <div class="form-error" id="tg-error"></div>
          <div class="settings-actions">
            <button type="button" class="btn-ghost" id="clear-btn">Очистить токен</button>
            <button type="button" class="btn-ghost" id="test-btn">Проверить</button>
            <button type="button" class="btn-ghost" id="summary-btn">Сводка сейчас</button>
            <button type="submit" id="save-btn">Сохранить</button>
          </div>
          <div class="text-muted" style="margin-top: 10px; font-size: 0.8rem;">
            Последнее изменение: ${tg.updatedAt ? new Date(tg.updatedAt).toLocaleString('ru') : '—'}
          </div>
        </form>
        <details class="settings-help">
          <summary>Как получить токен и chat ID</summary>
          <ol>
            <li>Напиши <a href="https://t.me/BotFather" target="_blank" rel="noopener">@BotFather</a> — <code>/newbot</code>, получи токен вида <code>1234567:AAF...</code></li>
            <li>Напиши созданному боту любое сообщение. Затем открой <code>https://api.telegram.org/bot&lt;token&gt;/getUpdates</code> в браузере — там увидишь <code>chat.id</code>.</li>
            <li>Для группы: добавь бота в группу, сделай его админом, напиши что-нибудь и посмотри <code>getUpdates</code> — chat.id будет отрицательным числом.</li>
          </ol>
        </details>
      </details>

      <details class="settings-card">
        <summary class="settings-card-head">
          <div>
            <h2>Лимит пользователей</h2>
            <p class="text-muted">Ограничение для бета-теста. Регистрации сверх лимита будут предлагать форму waitlist.</p>
          </div>
          <div class="settings-card-status">
            ${limits.userLimit
              ? `<span class="status-pill status-${limits.currentUsers >= limits.userLimit ? 'resolved' : 'open'}">${limits.currentUsers}/${limits.userLimit}</span>`
              : `<span class="status-pill status-waiting">Без лимита</span>`}
          </div>
        </summary>
        <form id="limit-form" class="settings-form">
          <div class="field">
            <label>Максимум активных пользователей</label>
            <input type="number" min="0" max="1000000" id="f-limit" value="${limits.userLimit ?? ''}" placeholder="Пусто = без лимита" />
            <div class="field-hint text-muted">Сейчас зарегистрировано: <strong>${limits.currentUsers}</strong>. Поставь 0 или пусто, чтобы снять лимит.</div>
          </div>
          <div class="form-error" id="limit-error"></div>
          <div class="settings-actions">
            <button type="submit" id="limit-save">Сохранить лимит</button>
          </div>
        </form>
      </details>

      <details class="settings-card">
        <summary class="settings-card-head">
          <div>
            <h2>Скорость и ритм</h2>
            <p class="text-muted">Калибровка под пользователя: первые ${gate.calibrationDays} дн. собираем данные, потом метрики ± толерантность.</p>
          </div>
          <div class="settings-card-status">
            ${gate.enabled
              ? `<span class="status-pill status-open">${gate.profilesCalibrated}/${gate.profilesTotal}</span>`
              : `<span class="status-pill status-resolved">Выкл</span>`}
          </div>
        </summary>
        <form id="gate-form" class="settings-form">
          <div class="field field-checkbox">
            <label><input type="checkbox" id="g-enabled" ${gate.enabled ? 'checked' : ''} /> Включить оценку скорости/ритма</label>
            <div class="field-hint text-muted">Если выключено — попытки оцениваются только по тексту и ошибкам, как раньше.</div>
          </div>
          <div class="field">
            <label>Дней калибровки</label>
            <input type="number" min="0" max="60" id="g-cal" value="${gate.calibrationDays}" />
            <div class="field-hint text-muted">Сколько дней с первой попытки система просто собирает данные, не отбраковывая по скорости/ритму.</div>
          </div>
          <div class="field">
            <label>Толерантность по WPM (доля)</label>
            <input type="number" min="0" max="1" step="0.01" id="g-tw" value="${gate.toleranceWpm}" />
            <div class="field-hint text-muted">Например, 0.20 = попытка проходит, если WPM ≥ медиана × 0.80.</div>
          </div>
          <div class="field">
            <label>Толерантность по ритму (доля)</label>
            <input type="number" min="0" max="1" step="0.01" id="g-tr" value="${gate.toleranceRhythm}" />
            <div class="field-hint text-muted">0.20 = ритм проходит, если стандартное отклонение IKI ≤ медиана × 1.20.</div>
          </div>
          <div class="form-error" id="gate-error"></div>
          <div class="settings-actions">
            <button type="submit" id="gate-save">Сохранить</button>
          </div>
        </form>
      </details>

      <details class="settings-card">
        <summary class="settings-card-head">
          <div>
            <h2>Waitlist</h2>
            <p class="text-muted">Заявки от пользователей, которым не хватило места во время бета-теста.</p>
          </div>
          <div class="settings-card-status" id="waitlist-count"><span class="status-pill status-waiting">…</span></div>
        </summary>
        <div id="waitlist-body" class="text-muted">Загрузка…</div>
      </details>
    `;

    const err = body.querySelector('#tg-error');

    body.querySelector('#tg-form').addEventListener('submit', async (e) => {
      e.preventDefault();
      err.textContent = '';
      const token = body.querySelector('#f-token').value.trim();
      const chat = body.querySelector('#f-chat').value.trim();
      const patch = {};
      if (token) patch.telegramBotToken = token;
      patch.telegramAdminChatId = chat || null;
      try {
        await api.adminSettings.updateIntegrations(patch);
        toast('Сохранено', { type: 'success' });
        await reload();
      } catch (e2) {
        err.textContent = e2.message || 'Не удалось сохранить';
      }
    });

    body.querySelector('#clear-btn').addEventListener('click', async () => {
      if (!confirm('Очистить сохранённый токен? Будет использоваться значение из env (если есть).')) return;
      try {
        await api.adminSettings.updateIntegrations({ telegramBotToken: null });
        toast('Токен очищен', { type: 'success' });
        await reload();
      } catch (e2) {
        err.textContent = e2.message;
      }
    });

    body.querySelector('#test-btn').addEventListener('click', async () => {
      err.textContent = '';
      try {
        await api.adminSettings.testTelegram();
        toast('Тестовое сообщение отправлено', { type: 'success' });
      } catch (e2) {
        if (e2.status === 400) err.textContent = 'Не заданы токен или chat ID';
        else err.textContent = 'Telegram ответил ошибкой: ' + (e2.body?.detail ?? e2.message);
      }
    });

    body.querySelector('#summary-btn').addEventListener('click', async () => {
      err.textContent = '';
      try {
        await api.adminSettings.triggerDailySummary();
        toast('Сводка отправлена (или скрыта если активности нет)', { type: 'success' });
      } catch (e2) {
        err.textContent = 'Не удалось отправить сводку: ' + (e2.body?.detail ?? e2.message);
      }
    });

    const gateErr = body.querySelector('#gate-error');
    body.querySelector('#gate-form').addEventListener('submit', async (e) => {
      e.preventDefault();
      gateErr.textContent = '';
      const patch = {
        enabled: body.querySelector('#g-enabled').checked,
        calibrationDays: Number(body.querySelector('#g-cal').value),
        toleranceWpm: Number(body.querySelector('#g-tw').value),
        toleranceRhythm: Number(body.querySelector('#g-tr').value),
      };
      if (!Number.isInteger(patch.calibrationDays) || patch.calibrationDays < 0) {
        gateErr.textContent = 'Дней калибровки — целое неотрицательное число';
        return;
      }
      if (patch.toleranceWpm < 0 || patch.toleranceWpm > 1 || patch.toleranceRhythm < 0 || patch.toleranceRhythm > 1) {
        gateErr.textContent = 'Толерантность — доля от 0 до 1';
        return;
      }
      try {
        await api.adminSettings.updateTypingGate(patch);
        toast('Сохранено', { type: 'success' });
        await reload();
      } catch (e2) {
        gateErr.textContent = e2.message || 'Не удалось сохранить';
      }
    });

    const limitErr = body.querySelector('#limit-error');
    body.querySelector('#limit-form').addEventListener('submit', async (e) => {
      e.preventDefault();
      limitErr.textContent = '';
      const raw = body.querySelector('#f-limit').value.trim();
      const value = raw === '' || Number(raw) === 0 ? null : Number(raw);
      if (value !== null && (!Number.isInteger(value) || value < 0)) {
        limitErr.textContent = 'Введи целое неотрицательное число';
        return;
      }
      try {
        await api.adminSettings.updateLimits({ userLimit: value });
        toast('Лимит сохранён', { type: 'success' });
        await reload();
      } catch (e2) {
        limitErr.textContent = e2.message || 'Не удалось сохранить';
      }
    });
  }

  async function loadWaitlist() {
    const list = body.querySelector('#waitlist-body');
    const counter = body.querySelector('#waitlist-count');
    if (!list) return;
    try {
      const data = await api.adminSettings.listWaitlist({ limit: 200 });
      counter.innerHTML = `<span class="status-pill status-${data.total > 0 ? 'open' : 'waiting'}">${data.total}</span>`;
      if (!data.entries.length) {
        list.innerHTML = '<div class="text-muted">Пока никого нет.</div>';
        return;
      }
      list.innerHTML = `
        <table class="waitlist-table">
          <thead><tr><th>Email</th><th>Имя</th><th>Комментарий</th><th>Когда</th><th></th></tr></thead>
          <tbody>
            ${data.entries.map((e) => `
              <tr data-id="${e.id}">
                <td>${escapeHtml(e.email)}</td>
                <td>${escapeHtml(e.name || '—')}</td>
                <td class="waitlist-comment">${escapeHtml(e.comment || '')}</td>
                <td class="text-muted">${new Date(e.createdAt).toLocaleString('ru', { dateStyle: 'short', timeStyle: 'short' })}</td>
                <td><button class="btn-ghost btn-sm" data-action="del">Удалить</button></td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      `;
      list.querySelectorAll('button[data-action="del"]').forEach((btn) => {
        btn.addEventListener('click', async () => {
          const id = btn.closest('tr').dataset.id;
          if (!confirm('Удалить заявку?')) return;
          try {
            await api.adminSettings.deleteWaitlist(id);
            await loadWaitlist();
          } catch (e2) {
            toast('Не удалось удалить', { type: 'error' });
          }
        });
      });
    } catch (err) {
      list.textContent = 'Ошибка загрузки: ' + (err.message || '');
    }
  }

  await reload();
}

function escapeHtml(s) {
  return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
